module.exports = __webpack_public_path__ + "assets/img/ic-reload-hover.34989256.svg";